import { Image } from '@chakra-ui/react';

import { ThemeIcon, ThemeIconProps } from '../../components';
import DarkLogo from './assets/cenitz_dark.svg';
import LightLogo from './assets/cenitz_white.svg';

function LightIcon(): JSX.Element {
  return <Image alt="cenitz light icon" maxH="100%" src={DarkLogo} />;
}

function DarkIcon(): JSX.Element {
  return <Image alt="cenitz dark icon" maxH="100%" src={LightLogo} />;
}

export function Icon({ ...props }: ThemeIconProps): JSX.Element {
  return <ThemeIcon darkIcon={<DarkIcon />} lightIcon={<LightIcon />} {...props} />;
}
